// src/components/Navigation.js
import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Navigation = ({ connectionStatus, requestDemoConnectionStatus, user, logout }) => {
  const location = useLocation();

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
      <Container>
        <Navbar.Brand as={Link} to="/">Strapi Management Tool</Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="me-auto">
            <Nav.Link
              as={Link}
              to="/"
              active={location.pathname === '/'}
            >
              Cleanup Tool
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/request-demos"
              active={location.pathname === '/request-demos'}
            >
              Promo Signups
            </Nav.Link>
          </Nav>
          <Navbar.Text className="me-3">
            Main API: {' '}
            <span className={`badge ${connectionStatus?.success ? 'bg-success' : 'bg-danger'}`}>
              {connectionStatus?.success ? 'Connected' : 'Error'}
            </span>
          </Navbar.Text>
          <Navbar.Text className="me-3">
            Request Demo API: {' '}
            <span className={`badge ${requestDemoConnectionStatus?.success ? 'bg-success' : 'bg-danger'}`}>
              {requestDemoConnectionStatus?.success ? 'Connected' : 'Error'}
            </span>
          </Navbar.Text>
          <Nav>
            <span className="navbar-text me-3">
              Welcome, {user.name || user.username}
            </span>
            <Button variant="outline-light" size="sm" onClick={logout}>
              Logout
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
